import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import EditintroModal from "../../Models/IntroEditModel/IntroEdit";
import EditServicesModal from "../../Models/ServicesEditModel/EditServices";
import AddAlbum from "../../Models/AddAlbumsModel/addAlbums";
import AddPhotoUpload from "../../Models/AddPhotoModel/addPhoto";
import BusinessCardModel from "../../Models/BuisnessCardsModel/BuisnessCardsModel";
import VideoUpload from "../../Models/AddVideoModel/addVideo";
import { MediaGet } from "../../apis/api/GalleryApis";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { isImageFile, getDocumentIconDetails } from "../../utils/fileUtils";
import "./Profile.css";

const fadeUp = { hidden:{opacity:0,y:14}, show:{opacity:1,y:0} };
const stagger = { show:{ transition:{ staggerChildren:.07 } } };

function fmtDate(ts) {
  if (!ts) return "—";
  const d = new Date(Number(ts) * 1000);
  if (isNaN(d)) return "—";
  return `${d.getDate()}-${["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()]}-${d.getFullYear()}`;
}

const LeftSidebar = ({ profileData, readOnly = false }) => {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const location  = useLocation();

  const [Photodata, setPhotodata] = useState([]);
  const [Videodata, setVideodata] = useState([]);
  const [showIntroModal,    setShowIntroModal]    = useState(false);
  const [showServiceModal,  setShowServiceModal]  = useState(false);
  const [showBuisnessModal, setShowBuisnessModal] = useState(false);
  const [addAlbum,          setAddAlbum]          = useState(false);
  const [addPhotoUpload,    setAddPhotoUpload]     = useState(false);
  const [videoUpload,       setaddVideo]           = useState(false);
  const [businessCardData,  setShowBuisnesscard]   = useState();

  const access     = JSON.parse(Cookies.get("access") || "{}");
  const cookieCompanyId = Cookies.get("company_id");
  const cookieUserId    = Cookies.get("userID");

  const galleryCompanyId =
    location.state?.company_id != null && location.state?.company_id !== ""
      ? String(location.state.company_id)
      : String(cookieCompanyId || "");
  const profileUserId =
    location.state?.userId != null && location.state?.userId !== ""
      ? String(location.state.userId)
      : String(cookieUserId || "");

  const [showPassword, setShowPassword] = useState(false);

  const { album } = useSelector(s => s.GallerySlice);
  const { media } = useSelector(s => s.GallerySlice);

  const company_data    = profileData?.data?.company_data;
  const member_data     = profileData?.data?.member_data;
  const service_data    = profileData?.data?.services;
  const Certificate_data = profileData?.data?.Certificates;

  useEffect(() => {
    if (galleryCompanyId) {
      dispatch(MediaGet({ company_id: galleryCompanyId }));
    }
  }, [dispatch, galleryCompanyId]);

  useEffect(() => {
    if (media?.result?.length > 0) {
      setPhotodata(media.result.filter(i => i.extension_type === "image"));
      setVideodata(media.result.filter(i => i.extension_type === "video"));
    } else {
      setPhotodata([]);
      setVideodata([]);
    }
  }, [media]);

  const hasAlbums = album?.result?.[0]?.data?.length > 0;
  const hasPhotos = Photodata.length > 0 && !!Photodata[0]?.file_url;
  const hasVideos = Videodata.length > 0 && !!Videodata[0]?.file_url;

  const filterMemberForCard = (id) => {
    setShowBuisnesscard(member_data.filter(m => m.id == id));
    setShowBuisnessModal(true);
  };

  const handleDownload = async (url, filename) => {
    try {
      const res  = await fetch(url, { mode:"cors" });
      const blob = await res.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "certificate";
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch(e) { console.error("Download failed:", e); }
  };

  const go = (path) =>
    navigate(path, {
      state: {
        from: location.pathname,
        company_id: galleryCompanyId,
        userId: profileUserId,
      },
    });

  const infoItems = [
    { icon:"bx bx-calendar-check", label:"Membership Start", val: fmtDate(company_data?.membership_start) },
    { icon:"bx bx-calendar-x",     label:"Membership End",   val: fmtDate(company_data?.membership_expire) },
    { icon:"bx bx-building",       label:"Founded",          val: fmtDate(company_data?.foundation_date) },
    { icon:"bx bx-key",            label:"Pay Password",     val: company_data?.pay_password || "—", isPassword: true },
    { icon:"bx bx-gift",           label:"Referral Code",    val: company_data?.referral_code || "—" },
  ];

  return (
    <>
      {!readOnly && (
        <>
          <EditintroModal    show={showIntroModal}    handleClose={() => setShowIntroModal(false)}    data={company_data} />
          <EditServicesModal show={showServiceModal}  handleClose={() => setShowServiceModal(false)}  servicesData={service_data} />
          <AddAlbum          show={addAlbum}          handleClose={() => setAddAlbum(false)} />
          <AddPhotoUpload    show={addPhotoUpload}     handleClose={() => setAddPhotoUpload(false)} />
          <VideoUpload       show={videoUpload}        handleClose={() => setaddVideo(false)} />
        </>
      )}
      <BusinessCardModel show={showBuisnessModal} handleClose={() => setShowBuisnessModal(false)} data={businessCardData} />

      <motion.div variants={stagger} initial="hidden" animate="show"
        style={{ display:"flex", flexDirection:"column", gap:"1.25rem" }}>

        {/* ── INTRO ── */}
        <motion.div className="pf-card" variants={fadeUp}>
          <div className="pf-card-head">
            <h2 className="pf-card-title"><i className="bx bx-info-circle"></i> Intro</h2>
            {!readOnly && (
              <button className="pf-edit-btn" onClick={() => setShowIntroModal(true)} type="button">
                <i className="bx bx-edit"></i> Edit
              </button>
            )}
          </div>
          <div className="pf-card-body">
            <p className="pf-bio-text">
              {company_data?.bio
                ? company_data.bio.replace(/<[^>]*>?/gm,"")
                : "No bio added yet."}
            </p>
            <ul className="pf-info-list">
              {infoItems.map(item => (
                <li key={item.label} className="pf-info-item">
                  <i className={item.icon}></i>
                  <span>
                    <span className="pf-info-label">{item.label}:</span>
                    {item.isPassword ? (
                      <span style={{ display:"inline-flex", alignItems:"center", gap:"6px" }}>
                        {showPassword ? item.val : "••••••••"}
                        <button
                          type="button"
                          onClick={() => setShowPassword(p => !p)}
                          style={{ background:"none", border:"none", cursor:"pointer", padding:0, color:"#64748b", fontSize:"1rem", lineHeight:1 }}
                          title={showPassword ? "Hide" : "Show"}
                        >
                          <i className={`bx ${showPassword ? "bx-hide" : "bx-show"}`}></i>
                        </button>
                      </span>
                    ) : item.val}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>

        {/* ── SERVICES ── */}
        <motion.div className="pf-card" variants={fadeUp}>
          <div className="pf-card-head">
            <h2 className="pf-card-title"><i className="bx bx-briefcase"></i> Services</h2>
            {!readOnly && (
              <button className="pf-edit-btn" onClick={() => setShowServiceModal(true)} type="button">
                <i className="bx bx-edit"></i> Edit
              </button>
            )}
          </div>
          <div className="pf-card-body">
            {service_data?.length > 0 ? (
              <div className="pf-services-grid">
                {service_data.map((s, i) => (
                  <motion.div key={i} className="pf-service-item"
                    whileHover={{ y:-2 }}>
                    {s.icon_url && <img src={s.icon_url} alt="" />}
                    <span>{s.service_name}</span>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="pf-empty"><i className="bx bx-briefcase"></i>No services added.</div>
            )}
          </div>
        </motion.div>

        {/* ── CONTACTS ── */}
        <motion.div className="pf-card" variants={fadeUp}>
          <div className="pf-card-head">
            <h2 className="pf-card-title"><i className="bx bx-group"></i> Contacts</h2>
            {!readOnly && (
              <button className="pf-edit-btn" onClick={() => go("/member")} type="button">
                <i className="bx bx-edit"></i> Edit
              </button>
            )}
          </div>
          <div className="pf-card-body">
            {member_data?.length > 0 ? (
              <div className="pf-contacts-grid">
                {member_data.map((m, i) => (
                  <motion.div key={i} className="pf-contact-card"
                    whileHover={{ y:-3 }}>
                    <img
                      src={m?.member_logo || `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`}
                      onError={e => { e.target.onerror=null; e.target.src=`${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`; }}
                      className="pf-contact-img" alt={m.first_name} />
                    <div className="pf-contact-body">
                      <p className="pf-contact-name">
                        {`${m.salutation||""} ${m.first_name||""} ${m.middle_name||""} ${m.last_name||""}`.trim()}
                      </p>
                      {m.job_title && <p className="pf-contact-title">{m.job_title}</p>}
                      {(() => {
                        const branchLoc = [m.branch_city, m.branch_country].filter(Boolean).join(", ");
                        return (branchLoc || m.branch_type || m.branch_id) ? (
                          <p className="pf-contact-branch">
                            <i className="bx bx-buildings"></i>
                            <span>
                              {branchLoc
                                ? `${branchLoc} ${m.branch_main_branch === 1 ? '(HQ)' : '(Branch)'}`
                                : (m.branch_type || (m.branch_main_branch === 1 ? 'Head Office' : 'Branch Office'))}
                            </span>
                          </p>
                        ) : null;
                      })()}
                      {m.contact && (
                        <p className="pf-contact-info">
                          <i className="bx bx-phone"></i>+{m.country_code}{m.contact}
                        </p>
                      )}
                      {m.email && (
                        <p className="pf-contact-info">
                          <i className="bx bx-envelope"></i>{m.email}
                        </p>
                      )}
                    </div>
                    <div className="pf-contact-actions">
                      {m.contact && (
                        <a href={`https://wa.me/${String(m.country_code).replace(/\D/g,"")}${String(m.contact).replace(/\D/g,"")}`}
                          target="_blank" rel="noopener noreferrer"
                          className="pf-contact-social" style={{ background:"#25d366", color:"#fff", borderRadius:"50%" }}>
                          <i className="bx bxl-whatsapp"></i>
                        </a>
                      )}
                      {m.email && (
                        <a href={`mailto:${m.email}`}
                          className="pf-contact-social" style={{ background:"#ea4335", color:"#fff", borderRadius:"50%" }}>
                          <i className="bx bx-envelope"></i>
                        </a>
                      )}
                      <button className="pf-card-btn" onClick={() => filterMemberForCard(m.id)}>
                        <i className="bx bx-id-card"></i> Card
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="pf-empty"><i className="bx bx-group"></i>No contacts added.</div>
            )}
          </div>
        </motion.div>

        {/* ── CERTIFICATES ── */}
        <motion.div className="pf-card" variants={fadeUp}>
          <div className="pf-card-head">
            <h2 className="pf-card-title"><i className="bx bx-award"></i> Certificates</h2>
            {!readOnly && (
              <button className="pf-edit-btn" onClick={() => go("/certificates")} type="button">
                <i className="bx bx-edit"></i> Edit
              </button>
            )}
          </div>
          <div className="pf-card-body">
            {Certificate_data?.length > 0 ? (
              <>
                <div className="pf-certs-grid">
                  {Certificate_data.slice(0,3).map(cert => {
                    const url = cert.file_url ? cert.file_url.replace("thumb/","") : "#";
                    const isImg = isImageFile(cert);
                    const docDetails = getDocumentIconDetails(cert);
                    return (
                      <motion.div key={cert.id} className="pf-cert-card" whileHover={{ y:-3 }}>
                        <div className="pf-cert-thumb" style={!isImg ? { backgroundColor: docDetails.bg } : {}}>
                          {isImg ? (
                            <img
                              src={cert.file_url}
                              alt={cert.title}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.style.display = "none";
                                if (e.currentTarget.parentElement) {
                                  const i = document.createElement("i");
                                  i.className = docDetails.icon;
                                  i.style.color = docDetails.color;
                                  e.currentTarget.parentElement.appendChild(i);
                                }
                              }}
                            />
                          ) : (
                            <i className={docDetails.icon} style={{ color: docDetails.color }}></i>
                          )}
                        </div>
                        <div className="pf-cert-body">
                          <p className="pf-cert-name" title={cert.title}>{cert.title}</p>
                          <p className="pf-cert-date">{new Date(cert.created_at*1000).toLocaleDateString()}</p>
                          <div className="pf-cert-actions">
                            <a href={url} target="_blank" rel="noopener noreferrer" className="pf-cert-btn view">
                              <i className="bx bx-show"></i> View
                            </a>
                            <button className="pf-cert-btn dl" onClick={() => handleDownload(url, cert.title)}>
                              <i className="bx bx-download"></i>
                            </button>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </div>
                {Certificate_data.length > 3 && (
                  <div className="pf-view-more">
                    <button className="pf-view-more-btn" onClick={() => go("/certificates")}>
                      View All <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="pf-empty"><i className="bx bx-award"></i>No certificates added.</div>
            )}
          </div>
        </motion.div>

        {/* ── MEDIA ── */}
        {access.gallery_access === "1" && (
          <motion.div className="pf-card" variants={fadeUp}>
            <div className="pf-card-head">
              <h2 className="pf-card-title"><i className="bx bx-images"></i> Media</h2>
            </div>
            <div className="pf-card-body">
              {!readOnly && (
                <div className="pf-media-actions">
                  <button className="pf-media-add" onClick={() => setAddAlbum(true)} type="button">
                    <i className="bx bx-plus"></i> Album
                  </button>
                  <button className="pf-media-add" onClick={() => setAddPhotoUpload(true)} type="button">
                    <i className="bx bx-plus"></i> Photo
                  </button>
                  <button className="pf-media-add" onClick={() => setaddVideo(true)} type="button">
                    <i className="bx bx-plus"></i> Video
                  </button>
                </div>
              )}

              {hasAlbums || hasPhotos || hasVideos ? (
                <div className="pf-media-grid">
                  {hasAlbums && (
                    <motion.div className="pf-media-card" whileHover={{ y:-3 }}
                      onClick={() => go("/albumCard")}>
                      <div className="pf-media-thumb">
                        {album.result[0].data[0]?.extension_type === "image"
                          ? <img src={album.result[0].data[0].file_url} alt="album" />
                          : <video src={album.result[0].data[0]?.file_url} muted />}
                      </div>
                      <div className="pf-media-label"><i className="bx bx-images"></i> Albums</div>
                    </motion.div>
                  )}
                  {hasPhotos && (
                    <motion.div className="pf-media-card" whileHover={{ y:-3 }}
                      onClick={() => go("/photos-gallery")}>
                      <div className="pf-media-thumb">
                        <img src={Photodata[0].file_url} alt="photo" />
                      </div>
                      <div className="pf-media-label"><i className="bx bx-photo-album"></i> Photos</div>
                    </motion.div>
                  )}
                  {hasVideos && (
                    <motion.div className="pf-media-card" whileHover={{ y:-3 }}
                      onClick={() => go("/videos-gallery")}>
                      <div className="pf-media-thumb">
                        <video src={Videodata[0].file_url} muted playsInline />
                      </div>
                      <div className="pf-media-label"><i className="bx bx-video"></i> Videos</div>
                    </motion.div>
                  )}
                </div>
              ) : (
                <div className="pf-empty"><i className="bx bx-images"></i>No media uploaded yet.</div>
              )}
            </div>
          </motion.div>
        )}

      </motion.div>
    </>
  );
};

export default LeftSidebar;
